import React, { useEffect, useState } from "react";
// import { ReactComponent as Branding } from "../Assets/branding.svg";
// import { ReactComponent as Development } from "../Assets/development.svg";
// import { ReactComponent as Design } from "../Assets/design.svg";
import Works from "../Components/Works";
import { useScroll, motion } from "framer-motion";
import {
  Logo,
  Development,
  Branding,
  Design,
} from "../svg components/svgComponents";
import Contact from "../Components/Contact";

function Home() {
  const { scrollY } = useScroll();
  const [scrollMoved, setScrollMoved] = useState(false);
  const [developmentShow, setDevelopmentShow] = useState(false);
  const [brandingShow, setBrandingShow] = useState(false);
  const [designShow, setDesignShow] = useState(false);
  const [Line, setLine] = useState("");

  useEffect(() => {
    return scrollY.onChange((latest) => {
      if (window.innerWidth >= 767) {
        latest > 50 ? setScrollMoved(true) : setScrollMoved(false);
        latest > 399 ? setDevelopmentShow(true) : setDevelopmentShow(false);
        latest > 860 ? setDesignShow(true) : setDesignShow(false);
        latest > 1300 ? setBrandingShow(true) : setBrandingShow(false);

      } else if(window.innerWidth >300) {
        latest > 50 ? setScrollMoved(true) : setScrollMoved(false);
        latest > 399 ? setDevelopmentShow(true) : setDevelopmentShow(false);
        latest > 1200 ? setDesignShow(true) : setDesignShow(false);
        latest > 1870 ? setBrandingShow(true) : setBrandingShow(false);
      }
      
      else{
        latest > 50 ? setScrollMoved(true) : setScrollMoved(false);
        latest > 500 ? setDevelopmentShow(true) : setDevelopmentShow(false);
        latest > 1450 ? setDesignShow(true) : setDesignShow(false);
        latest > 2300 ? setBrandingShow(true) : setBrandingShow(false);
        
      }

      if (latest > 399 && 800 > latest) {
        return setLine("develop");
      } else if (latest > 1100 && 1400 > latest) {
        return setLine("design");
      } else if (latest > 1850 && 2000 > latest) {
        return setLine("brand");
      }
    });
  }, []);

  const symbolsVariant = {
    start: { opacity: 0 },
    static: {
      opacity: 1,
      transition: { duration: 0.2 },
      x: `${
        window.innerWidth <= 300
          ? "-210px"
          : window.innerWidth <= 639
          ? "-185px"
          : window.innerWidth < 768
          ? "-110px"
          : "0px"
      }`,
    },
    moved: {
      x: `${window.innerWidth <= 300? "-210px":
        window.innerWidth <= 360
          ? "-200px"
          : window.innerWidth <= 470
          ? "-150px"
          : window.innerWidth <= 530
          ? "-110px"
          : window.innerWidth <= 639
          ? "-90px"
          : window.innerWidth <= 767
          ? "-60px"
          : window.innerHeight <= 1000
          ? "60px"
          : "140px"
      }`,
      rotate: "90deg",
      opacity: 1,
      transition: { duration: 0.2 },
    },
  };
  // const sectionVariants = {
  //     visible: { y: [450, 0], transition: { duration: 3 } },
  // };
  const opacityVariant = {
    initial: { width: "0%" },
    visible: { width: "100%", transition: { duration: 0.5 } },
  };
  return (
    <div className="px-8">
      {/* showcase */}
      <div className="flex  justify-center items-center mt-[16.5rem] flex-col relative ">
        <a
          href="#contact"
          className="sm:visible invisible fixed font-bold left-0 bottom-28 md:px-9 md:py-8 sm:px-4 sm:py-5 text-[2rem] bg-purple rounded-lg text-white z-20 shadow-consult"
        >
          Free 20 Minute Consult
        </a>
        <div className="w-full">
          <div className="my-auto relative flex justify-center">
            <div>
              <Logo />
            </div>
            <div className="fixed ml-[66.5rem] md:top-[18.6rem] sm:top-[18.5rem] top-[17.3rem]">
              <motion.div
                className="flex flex-col items-center justify-center md:gap-y-[22px] gap-y-[5px]"
                variants={symbolsVariant}
                initial="start"
                animate={scrollMoved ? "moved" : "static"}
              >
                <div
                  className={`w-16 smallest-screen:w-16 sm:w-28 h-4 sm:h-5 bg-[#E6D350] rounded-3xl ${
                    brandingShow ? "expertises-fadeOut" : "expertises-fadeIn"
                  } smallest-screen:!h-3`}
                ></div>
                <div
                  className={`w-16 smallest-screen:w-16 sm:w-28 h-4 sm:h-5 bg-[#DE3592] rounded-3xl ${
                    designShow ? "expertises-fadeOut" : "expertises-fadeIn"
                  } smallest-screen:!h-3`}
                ></div>
                <motion.div
                  className={`w-16 smallest-screen:w-16 sm:w-28 h-4 sm:h-5 bg-[#36BFD1] rounded-3xl ${
                    developmentShow ? "expertises-fadeOut" : "expertises-fadeIn"
                  } smallest-screen:!h-3`}
                  // variants={sectionVariants}
                  // initial="start"
                  // animate={Line && "visible"}
                ></motion.div>
              </motion.div>
            </div>
          </div>
        </div>

        <p className="mx-auto text-[1.8rem] sm:text-[2.4rem]  leading-[2.8rem] md:w-[75rem] sm:w-[50rem] mt-16 px-2">
          If you want to be remembered as a unique and creative brand, we are
          here for you. With years of experience and a professional team, we
          help you to invent your brand, design it and develop it.
        </p>
      </div>
      {/* expertises */}
      <div className="container mt-[10rem]">
        <h2 className="sm:text-left text-center text-[3rem] sm:text-[4rem] ">Expertises</h2>
        <div className="flex md:flex-row flex-col justify-around items-center mt-28">
          <div className="svg">
            <Development />
          </div>
          <div className="relative mt-[10rem] flex flex-col items-center justify-center">
            <h3 className="smallest-screen:text-[2rem] small-screen:text-[2.3rem] smaller-screen:text-[3.2rem] text-center sm:[text-left] leading-[7.5rem] absolute  -top-44 smaller-screen:-top-32">
              <motion.div
                className="PRODUCT DEVELOPMENT h-8 bg-blue -z-10 absolute top-14 rounded-lg"
                initial="initial"
                animate={developmentShow ? "visible" : "initial"}
                variants={opacityVariant}
              ></motion.div>
              PRODUCT DEVELOPMENT
            </h3>
            <p className="leading-[2.8rem] text-[1.8rem] sm:w-[50rem]">
              Here at development department, we have a great team with years of
              experience. There can not anything you need that our development
              team can't make. they really do magic with their keyboards!
            </p>
            <p className="leading-[2.8rem] text-[1.8rem] mt-8 sm:w-[50rem]">
              we can support your product in both Front-end and Back-end
              section. Our team has done projects in front with ReactJS in
              Front-end and Django in Back-end.
            </p>
          </div>
        </div>
        <div className="flex md:flex-row flex-col justify-around items-center  mt-[12rem]">
          <div className="">
            <Design />
          </div>
          {/* from here */}
          <div className="relative mt-[10rem] flex flex-col items-center justify-center">
            <h3 className="smallest-screen:text-[2rem] small-screen:text-[2.3rem] smaller-screen:text-[3.2rem] text-center sm:[text-left] leading-[7.5rem] absolute  -top-44 smaller-screen:-top-32">
              <motion.div
                className="text-center sm:[text-left] h-8 bg-pink -z-10 absolute top-14 rounded-lg"
                initial="initial"
                animate={designShow ? "visible" : "initial"}
                variants={opacityVariant}
              ></motion.div>
              PRODUCT DESIGN
            </h3>
            <p className="leading-[2.8rem] text-[1.8rem] sm:w-[50rem]">
              Designing is one of the most important fields when you want to be
              unique. On the other hand, it is a job with lots of skills and
              talents needed. As a result you need a team who has proven them
              self in ways that they should be!
            </p>
            <p className="leading-[2.8rem] text-[1.8rem] mt-8 sm:w-[50rem]">
              Our designers are who we are proud of. They're heros who make your
              brand or product good-looking and also user-friendly. Isn't that
              the dream?
            </p>
          </div>
        </div>
        <div className="flex md:flex-row flex-col justify-around items-center mt-[12rem]">
          <div className="">
            <Branding />
          </div>
          <div className="relative mt-[10rem] flex flex-col items-center justify-center">
            <h3 className="smallest-screen:text-[2rem] small-screen:text-[2.3rem] smaller-screen:text-[3.2rem] text-center sm:[text-left] leading-[7.5rem] absolute  -top-44 smaller-screen:-top-32">
              <motion.div
                className="h-8 bg-yellow -z-10 absolute top-14 rounded-lg"
                initial="initial"
                animate={brandingShow ? "visible" : "initial"}
                variants={opacityVariant}
              ></motion.div>
              PRODUCT BRANDING
            </h3>
            <p className="leading-[2.8rem] text-[1.8rem] sm:w-[50rem]">
              Your brand needs to be seen; and being seen seems impossible these
              days. But is it really? Well I can assure you that if you have the
              right team in your pocket, it can be done pleasantly.
            </p>
            <p className="leading-[2.8rem] text-[1.8rem] mt-8 sm:w-[50rem]">
              You can fully trust our experts in branding field to help you
              build a brand which can make your dreams come true.
            </p>
          </div>
        </div>
      </div>
      {/* work */}
      <div className="container mt-[8rem]">
        <Works />
      </div>
      <div className="">
        {/* contact */}
        <Contact />
      </div>
    </div>
  );
}

export default Home;
